import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCreateCustomerUserDataMutation } from "store/services/customerUserApi";
import CustomerUserForm from "./customerComponents/CustomerUserForm";

const CustomerUserCreateScreen = () => {
  const [createCustomerUser, { isLoading: creatingCustomerUser }] =
    useCreateCustomerUserDataMutation();
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Customer",
      path: "/app/crm/customerUser/list",
    },
    { title: "New Customer" },
  ];

  // Create Customer User
  const handleCreateCustomerUser = async (data) => {
    createCustomerUser(data)
      .unwrap()
      .then(() => {
        navigate(breadcrumbs[0].path);
        toast.success("Customer User created successfully");
      })
      .catch((error) => {
        const errorMessage = error?.data?.message || "Something went wrong!";
        toast.error(errorMessage);
      });
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingCustomerUser}>
      <BreadcrumbLayout.Paper>
        <CustomerUserForm
          isBusy={creatingCustomerUser}
          onSubmit={handleCreateCustomerUser}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CustomerUserCreateScreen;
